import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.faqContainer = this.element.querySelector('#faqContainer');
    this.topicSelector = this.element.querySelector('#topicSelector');
    this.adminAjaxUrl = '/wp-admin/admin-ajax.php';
    this.loader = this.element.querySelector('.loader');
    this.currentTimeout = null;
    this.displayedPosts = this.element.dataset.displayedPosts;
    this.frontPage = Boolean(this.element.dataset.frontPage);

    this.loadPosts(0, -1)

    this.topicSelector.addEventListener('change', ()=>{
      this.loadPosts(500, this.topicSelector.value);
    })
  }



  loadPosts(delay, topic) {
    clearTimeout(this.currentTimeout);
    this.currentTimeout = setTimeout(() => {
      this.faqContainer.innerHTML = '';
      this.loader.classList.remove('d-none');

      let formData = new FormData;
      formData.append('action', 'faq_load_posts');
      formData.append('perPage', this.displayedPosts);
      formData.append('isFrontPage', this.frontPage);
      formData.append('topic', topic);

      axios.post(this.adminAjaxUrl, formData).then((response)=>{
        if (response.data.html) {
          this.loader.classList.add('d-none');
          this.faqContainer.innerHTML += response.data.html;
        }
      });
    }, delay);
  }
}
